// accountSelectionSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { AccountSelectionState } from '../types';

//~ Keep a reference to this slice's name for cleanup in case of persistReducer usage
export const name = 'accountSelection';

//~ Initialize your state here
const initialState: AccountSelectionState = {
    selectedAccount: undefined,
};

export const accountSelectionSlice = createSlice({
    name,
    initialState,
    reducers: {
        //~ Define your synchronous reducers here
        clearSelectedAccount: () => {
            return initialState;
        },
        setAccount: (state, action) => {
            state.selectedAccount = action.payload;
        },
    },
    selectors: {
        //~ Define your selectors here

        selectSelectedAccount: (sliceState) => sliceState.selectedAccount,
        selectIsAccountSelected: (sliceState) => !!sliceState.selectedAccount,

        selectSelectedAccountId: (sliceState) => sliceState.selectedAccount?.id,
        selectSelectedAccountName: (sliceState) =>
            sliceState.selectedAccount?.name,
        selectSelectedAccountRights: (sliceState) =>
            sliceState.selectedAccount?.rights,
        selectSelectedAccountStatus: (sliceState) =>
            sliceState.selectedAccount?.status,
    },
});

//~ Export defined synchronous reducers here
export const { setAccount, clearSelectedAccount } =
    accountSelectionSlice.actions;

//~ Export defined selectors here
export const {
    selectSelectedAccount,
    selectIsAccountSelected,

    selectSelectedAccountId,
    selectSelectedAccountName,
    selectSelectedAccountRights,
    selectSelectedAccountStatus,
} = accountSelectionSlice.selectors;

export const accountSelectionReducer = accountSelectionSlice.reducer;
export default accountSelectionReducer;
